// extracted by mini-css-extract-plugin
export var orderSummary = "_la-0";
export var showMoreLessButton = "_la-1";